module.exports = __webpack_public_path__ + "img/avnon-1.fcd39181.webp";